import React from 'react';
import { FiMenu, FiBell } from 'react-icons/fi';
import { useAuthStore } from '../store/authStore';
import { getInitials } from '../utils/formatters';
import ViewSwitcher from './ViewSwitcher';

const Header = ({ title, onToggleSidebar }) => {
  const user = useAuthStore((state) => state.user);

  return (
    <header className="header">
      <div className="header-left">
        <button className="icon-btn" onClick={onToggleSidebar}>
          <FiMenu size={22} />
        </button>
        <h1 className="header-title">{title}</h1>
      </div>

      <div className="header-right">
        {/* Role switcher for multi-role users */}
        <ViewSwitcher />

        <button className="icon-btn">
          <FiBell size={22} />
        </button>
        <div className="user-info">
          <div className="user-avatar">
            {user ? getInitials(user.first_name, user.last_name) : 'U'}
          </div>
          <div className="user-details">
            <div className="user-name">
              {user?.first_name} {user?.last_name}
            </div>
            <div className="user-role">
              <UserRoleLabel />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

// Small helper that shows the current portal under the user's name
const UserRoleLabel = () => {
  const activeView = useAuthStore((state) => state.activeView);
  const lraRole = useAuthStore((state) => state.lraRole);

  if (activeView === 'lra') {
    if (lraRole === 'admin') return <>LRA Administrator</>;
    if (lraRole === 'officer') return <>LRA Officer</>;
    if (lraRole === 'agent') return <>Field Agent</>;
  }
  return <>Merchant</>;
};

export default Header;
